import {
  FormLabel,
  ButtonGroup,
  Button,
  useToast,
  RadioGroup,
  Radio,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
} from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

import { FormPasswordInput } from '@/components/ui/form';
import { useChangePasswordPut } from '@/features/user/api/put-password';
import { ChangePasswordInput } from '@/features/user/schemas/change-password';
import { useHandleErrors } from '@/hooks/use-handle-api-error';
import { useWithLoading } from '@/utils/with-loading';

type PasswordChangeFormModalProps = {
  isPasswordChangeFormModalOpen: boolean;
  onPasswordChangeFormModalClose: () => void;
  onPasswordChangeCancelModalOpen: () => void;
  onMfaSettingModalOpen: () => void;
};

export const PasswordChangeFormModal = (
  props: PasswordChangeFormModalProps,
) => {
  console.info('password-change-form-modal.tsx_1');

  const {
    isPasswordChangeFormModalOpen,
    onPasswordChangeFormModalClose,
    onPasswordChangeCancelModalOpen,
    onMfaSettingModalOpen,
  } = props;

  const handleChangeModal = (value: string) => {
    console.info('password-change-form-modal.tsx_2');
    if (value === 'password') {
      console.info('password-change-form-modal.tsx_3');
      return;
    }
    console.info('password-change-form-modal.tsx_4');
    onMfaSettingModalOpen();
  };

  const {
    handleSubmit,
    formState: { errors },
    register,
    setError,
    reset,
  } = useFormContext<ChangePasswordInput>();

  const { handleErrors } = useHandleErrors(setError);
  const toast = useToast();

  const useChangePasswordPutMutation = useChangePasswordPut({
    mutationConfig: {
      onError: (error) => {
        console.info('password-change-form-modal.tsx_5');

        handleErrors(error);
      },
      onSuccess: () => {
        console.info('password-change-form-modal.tsx_6');

        toast({
          title: 'パスワードを変更しました',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        onPasswordChangeFormModalClose();
        reset({ current_password: '', password: '', confirm_password: '' });
      },
    },
  });

  // フォーム送信
  const onSubmit = useWithLoading(async (data: ChangePasswordInput) => {
    console.info('password-change-form-modal.tsx_7');

    await useChangePasswordPutMutation.mutateAsync({
      params: {
        current_password: data.current_password,
        password: data.password,
        confirm_password: data.confirm_password,
      },
    });
  });

  const currentPasswordInput = {
    error: errors['current_password'],
    placeholder: '現在のパスワード',
    register: register('current_password'),
    variant: {
      autoComplete: 'current-password',
      width: { base: '100%', md: '100%' },
    },
  };

  const passwordInput = {
    error: errors['password'],
    placeholder: '新しいパスワード',
    register: register('password'),
    variant: {
      autoComplete: 'new-password',
      width: { base: '100%', md: '100%' },
    },
  };

  const confirmPasswordInput = {
    error: errors['confirm_password'],
    placeholder: 'パスワードの確認入力',
    register: register('confirm_password'),
    variant: {
      autoComplete: 'new-password',
      width: { base: '100%', md: '100%' },
    },
  };

  const bodyContent = (
    <>
      <FormLabel>現在のパスワード</FormLabel>
      <FormPasswordInput {...currentPasswordInput} />
      <FormLabel>新しいパスワード</FormLabel>
      <FormPasswordInput {...passwordInput} />
      <FormLabel>パスワードの確認入力</FormLabel>
      <FormPasswordInput {...confirmPasswordInput} />
    </>
  );

  const footerContent = (
    <ButtonGroup>
      <Button variant="outline" onClick={onPasswordChangeCancelModalOpen}>
        キャンセル
      </Button>
      <Button
        colorScheme="blue"
        type="submit"
        form="form-inside-modal"
        onClick={handleSubmit(onSubmit)}
      >
        設定
      </Button>
    </ButtonGroup>
  );

  return (
    <Modal
      isOpen={isPasswordChangeFormModalOpen}
      onClose={onPasswordChangeCancelModalOpen}
    >
      <ModalOverlay bg="rgba(0, 0, 0, 0.3)" />
      <ModalContent>
        <ModalHeader bg="white" color="black"></ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontWeight="bold" fontSize="xl">
            パスワード設定
          </Text>
          <RadioGroup
            defaultValue="password"
            onChange={(value) => handleChangeModal(value)}
          >
            <Radio value="password" px={4} py={2}>
              パスワード変更
            </Radio>
            <Radio value="mfa" px={4} py={2}>
              二段階認証設定
            </Radio>
          </RadioGroup>
          <Text fontWeight="bold" fontSize="xl" mt={4} mb={2}>
            パスワード変更
          </Text>
          {bodyContent}
        </ModalBody>
        <ModalFooter>{footerContent}</ModalFooter>
      </ModalContent>
    </Modal>
  );
};
